'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var warn = function warn(s) {
  console.warn('[react-gtm]', s);
};

exports.default = warn;


//////////////////
// WEBPACK FOOTER
// ./~/react-gtm-module/dist/utils/warn.js
// module id = 3279
// module chunks = 4